'use client';

import { useState } from 'react';
import { ActionButton } from '../../../../components/form';
import FaIcon, { faChevronDown } from '../../../../components/icon/FaIcon/FaIcon';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { LotteryEvent } from '../../types';

export interface LotteryInfiniteListProps {
  lotteryEventList: Array<LotteryEvent>;
  pageLimit: number;
  query?: string;
  tagId?: number;
  requestTime: string;
  tab?: string;
  isSession?: boolean;
  getLotteryEventFunction: (params: {
    oemServiceId: number;
    requestTime: string;
    lotteryPositionKey: string;
    getType: string;
    limit: number;
    eventName?: string;
    lotteryEventTagId?: number;
    pagingLotteryEventId: number;
  }) => Promise<{ result: Array<LotteryEvent> }>;
  LotteryEventListComponent: React.ComponentType<{ lotteryEventList: Array<LotteryEvent> }>;
}

function LotteryInfiniteList({
  lotteryEventList,
  pageLimit,
  query,
  tagId,
  requestTime,
  tab,
  isSession = false,
  getLotteryEventFunction,
  LotteryEventListComponent,
}: LotteryInfiniteListProps) {
  const [hasNoMore, setHasNoMore] = useState(false);
  const [currentLotteryList, setCurrentLotteryList] = useState(lotteryEventList);

  const fetchMore = async () => {
    const lastId = currentLotteryList.slice(-1)[0].id;
    const { result: moreLotteryEventList } = await getLotteryEventFunction({
      oemServiceId: Number(process.env.NEXT_PUBLIC_SERVICE_ID),
      requestTime: requestTime, //初めの取得時と同じ時刻でないとページネートがズレる
      lotteryPositionKey: process.env.LOTTERIES_KEY || '',
      getType: tab || (isSession ? 'is_session' : 'new'),
      limit: pageLimit,
      eventName: query || undefined,
      lotteryEventTagId: tagId || undefined,
      pagingLotteryEventId: lastId,
    });
    if (moreLotteryEventList.length === 0) {
      setHasNoMore(true);
      return;
    }
    setCurrentLotteryList([...currentLotteryList, ...moreLotteryEventList]);
  };

  return (
    <>
      {currentLotteryList.length > 0 ? (
        <LotteryEventListComponent lotteryEventList={currentLotteryList} />
      ) : (
        <p className={`${utilsStyles.textSmall} ${utilsStyles.textCenter}`}>
          イベントが見つかりません、検索条件を変更してください。
        </p>
      )}
      <div className={utilsStyles.mtSmall}>
        <ActionButton
          color='white'
          size={'fullWidth'}
          onClick={fetchMore}
          disabled={hasNoMore || currentLotteryList.length === 0}
        >
          <p className={utilsStyles.blackColor}>
            MORE&nbsp;
            <FaIcon icon={faChevronDown} />
          </p>
        </ActionButton>
      </div>
    </>
  );
}

export default LotteryInfiniteList;
